import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "columns"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import Grid from '@mui/material/Grid';
import { gridTheme } from './gridStyles';
import { EmbersInnerThemeProvider } from '../rtlProvider';
export var EmbersGrid = function EmbersGrid(_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    columns = _ref.columns,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var withEmbersRootClass = classes !== null && classes !== void 0 && classes.root ? "".concat(classes.root, " EmbersGrid") : 'EmbersGrid';
  return /*#__PURE__*/React.createElement(EmbersInnerThemeProvider, {
    theme: gridTheme
  }, /*#__PURE__*/React.createElement(Grid, _extends({
    classes: _objectSpread(_objectSpread({}, classes), {}, {
      root: withEmbersRootClass
    }),
    columns: columns !== null && columns !== void 0 ? columns : {
      xs: 4,
      md: 8,
      lg: 12
    },
    columnSpacing: 2
  }, otherProps), children));
};